import { produce } from 'immer';
import type { StoreApi } from 'zustand';

export type SharedViewState = {
  isPreviewMode: boolean;
  previewPolygon: GeoJSON.Polygon | null;
  shareId: string | null;
  setPreviewMode: (polygon: GeoJSON.Polygon, shareId: string) => void;
  exitPreviewMode: () => void;
  clearSharedView: () => void;
};

export const createSharedViewSlice = (set: StoreApi<any>['setState']) => ({
  isPreviewMode: false,
  previewPolygon: null,
  shareId: null,
  setPreviewMode: (polygon: GeoJSON.Polygon, shareId: string) =>
    set(
      produce((draft: SharedViewState) => {
        draft.isPreviewMode = true;
        draft.previewPolygon = polygon;
        draft.shareId = shareId;
      })
    ),
  exitPreviewMode: () =>
    set(
      produce((draft: SharedViewState) => {
        draft.isPreviewMode = false;
        draft.previewPolygon = null;
        draft.shareId = null;
      })
    ),
  clearSharedView: () =>
    set(
      produce((draft: SharedViewState) => {
        draft.isPreviewMode = false;
        draft.previewPolygon = null;
        draft.shareId = null;
      })
    ),
});
